import FeatherIcon from "feather-icons-react/build/FeatherIcon";

export const FilterOverlay = (props) => {
  const filterOverlayToggle = props.isVisible ? 'show' : 'd-none';

  return (
    <div className={`filter_results_mask fade ${filterOverlayToggle}`}>
      <div className="position-absolute top-50 start-50 translate-middle">
        <h2 className="text-white text-center" style={{ fontWeight: 400 }}>
          Press{" "}
          <span style={{ verticalAlign: "middle", display: "inline-block" }}>
            <button
              type="button"
              className="btn btn-primary"
              style={{ pointerEvents: "none", opacity: 0.7, fontWeight: 500, letterSpacing: 0.5 }}
              tabIndex={-1}
              disabled
            >
              
              Filter
            </button>
          </span>{" "}
          to apply the newly selected filters
        </h2>
        <h3 className="text-white text-center" style={{ fontWeight: 400 }}>
          Press{" "}
          <span style={{ verticalAlign: "middle", display: "inline-block" }}>
            <button
              type="button"
              className="btn btn-outline-primary mt-3 px-2"
              style={{ pointerEvents: "none", opacity: 0.7 }}
              tabIndex={-1}
              disabled
            >
              <FeatherIcon icon="rotate-ccw" size={16} className="mx-1" />
            </button>
          </span>{" "}
          to reset filters to the previous settings
        </h3>
      </div>
    </div>
  );
};

export default FilterOverlay;